import React, { useState, useEffect } from "react";
import fetchData from "../../services/requester-website";
import { Currency } from "../../helpers/formatter";
import { Link } from "react-router-dom";
import { imagePath } from "../../helpers/global";
import { defaultSettings } from "../../helpers/default-settings";

const HomeDeals = (props) => {
  const [data, setData] = useState([]);

  const getData = () => {
    let reqURL = "deals/hotdeal";
    let reqOBJ = "";
    fetchData(
      reqURL,
      reqOBJ,
      (data) => {
        data && setData(data?.filter((x) => x?.showOnHome) || []);
      },
      "GET"
    );
  };

  useEffect(() => {
    getData();
  }, []);

  return (
    data &&
    data.length > 0 && (
      <div className="home-deals">
        <h2 className="home-title">
          {props?.dealsTitle || defaultSettings?.dealsTitle}
        </h2>
        <p className="home-sub-title">
          {props?.dealsSubTitle || defaultSettings?.dealsSubTitle}
        </p>
        <div className="row">
          {data?.map(
            (x, key) =>
              key < 4 && (
                <div key={key} className="col-lg-3">
                  <div className="home-deals-wrap">
                    <img src={imagePath() + x?.imageURL} alt={x?.title} />
                    <h3>{x?.title}</h3>
                    <h4>{Currency(x?.price)}</h4>
                    <Link to={"deals/" + x?.dealId} />
                  </div>
                </div>
              )
          )}
        </div>
      </div>
    )
  );
};

export default HomeDeals;
